import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { convertToCurrency } from "../../utils/conversion";

export const ProductEntry = ({ id, imageUrl, name, measure, price }) => {
  const isInOfferedProducts = useSelector(state => state.product.offeredProductMapping[id]);
  const history = useHistory();

  const selectProduct = () => {
    history.push("/product/" + id);
  }

  return (
    <div className="defaultListElement" onClick={() => selectProduct()}>
      <div className="elemImageContainer">
        {imageUrl ? <img src={imageUrl} alt="Produktbild" /> : <div className="imgEmpty" />}
      </div>
      <div className="elemInfoContainer">
        {isInOfferedProducts && <span><span className="badge">Im Sortiment</span></span>}
        <span className="medium">{name}</span>
        <span>{measure ? `${measure} · ` : ''}{convertToCurrency(parseFloat(price))}</span>
      </div>
    </div>
  )
}